import { useCallback, useEffect, useState, useRef } from "react";
import { useRecoilValue } from "recoil";
import { pubState } from "../../recoil/pub.atom";
import {
  GraphWrapper,
  MainWrapper,
  MemberWrapper,
  PageHeader,
  PageWrapper,
} from "./style";
import {
  DailySellerMemberResponse,
  getMemberDashboard,
  SellerMemberDto,
} from "../../api/member";
import MemberTableComponent, { MemberTableRef } from "./component/memberTable";
import MemberGraph from "./component/memberGraph";
import { Title } from "../../styles/page";
import MemberSearch from "./component/memberSearch";
import MemberGraphFilter from "./component/memberGraphFilter";
import MobileMember from "./component/mobile";
import { WideState } from "../../recoil/wide";
import MemberDetailModal from "./component/member-detail";
import { useNavigate } from "react-router-dom";
import { PubOwnerRole, PubOwnerDomain } from "../../api/cafe";

const Member = () => {
  const memberTableRef = useRef<MemberTableRef>(null);
  const [graphData, setGraphData] = useState<DailySellerMemberResponse[]>([]);
  const pub = useRecoilValue(pubState);
  const isWide = useRecoilValue(WideState);
  const [filterType, setFilterType] = useState<string>("daily");
  const [visit, setVisit] = useState<number>(0);
  const [register, setRegister] = useState<number>(0);
  const [order, setOrder] = useState<string>("DESC");
  const [sort, setSort] = useState<string>("");
  const customImage = new Image();
  customImage.src = "/image-web/dashboard/chart/pointer.svg";
  const [member, setMember] = useState<SellerMemberDto | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!pub) {
      navigate("/");
      return;
    }
    if (pub.role === PubOwnerRole.OWNER || pub.domains.length === 0) return;
    if (!pub?.domains.includes(PubOwnerDomain.MEMBER)) {
      navigate("/");
      alert("해당 페이지 접근 권한이 없습니다. ");
      return;
    }
  }, [navigate, pub]);

  const getData = useCallback(async () => {
    if (!pub) {
      return;
    }

    try {
      getMemberDashboard(pub.id, filterType).then((res) => setGraphData(res));
    } catch (e) {
      console.log(e);
    }
  }, [pub, filterType, sort, order]);

  useEffect(() => {
    getData();
  }, [filterType, order, sort]);

  useEffect(() => {
    if (graphData.length > 0) {
      setVisit(graphData[graphData.length - 1].visitCount);
      setRegister(graphData[graphData.length - 1].registerCount);
    }
  }, [graphData]);

  if (!isWide) {
    return <MobileMember />;
  }

  return (
    <PageWrapper>
      {member && (
        <MemberDetailModal
          member={member}
          setMember={setMember}
          refreshMemberList={() => {
            memberTableRef.current?.getList();
          }}
        />
      )}
      <PageHeader>
        <Title size={35} weight={700}>
          회원관리
        </Title>
      </PageHeader>
      <MainWrapper>
        <GraphWrapper>
          <MemberGraphFilter
            filterType={filterType}
            setFilterType={setFilterType}
          />
          <div className="main-box">
            <div className="box">
              <div className="title">방문한 회원</div>
              <div className="value">{visit.toLocaleString()}+</div>
            </div>
            <div className="box">
              <div className="title">가입한 신규 회원</div>
              <div className="value">{register.toLocaleString()}+</div>
            </div>
          </div>
          <MemberGraph graphData={graphData} filterType={filterType} />
        </GraphWrapper>
        <MemberWrapper>
          <MemberSearch
            getData={getData}
            refreshMemberList={() => {
              memberTableRef.current?.getList();
            }}
          />
          <MemberTableComponent
            ref={memberTableRef}
            order={order}
            setOrder={setOrder}
            sort={sort}
            setSort={setSort}
            setMember={setMember}
          />
        </MemberWrapper>
      </MainWrapper>
    </PageWrapper>
  );
};

export default Member;
